import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toaster } from "../../actions/showToast";

export default function AddTimer(props) {
  const { t } = useTranslation();
  // const dispatch = useDispatch();

  const onClickAddTimer = () => {
    // console.log("--Add a note..", props);
    // dispatch(toaster(t("Click a point to add a Timer"), "warning"));
    // props.changeMyTool("addtimer");
  };
  return (
    <li onClick={props.onClick}>
      <span
        className={`button normal-btn next-page is-hidden-mobile ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "addtimer" ? "active" : ""
        }`}
        title={t("Add Timer")}
        data-tip={t("Add Timer")}
      >
        <img
          src={require("../../assets/img/svg/tools-timer.svg")}
          alt={t("Add Timer")}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Timer")}</span>}
      </span>
    </li>
  );
}
